// src/components/store/sections/newsletter/NewsletterV38SplitcardSunsetAmber.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV38SplitcardSunsetAmber(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={38}
      archKey="split_card"
      archLabel="Floating Split Card"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
